import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e1646ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#f3f5f7"} }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "咨询服务", -1))
const _hoisted_4 = { class: "info-title" }
const _hoisted_5 = {
  key: 0,
  class: "title-left"
}
const _hoisted_6 = { class: "title-tips" }
const _hoisted_7 = { class: "info-contents" }
const _hoisted_8 = { class: "contents-goods" }
const _hoisted_9 = { class: "goods-left" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "goods-right" }
const _hoisted_12 = { class: "right-info" }
const _hoisted_13 = { class: "goods-title" }
const _hoisted_14 = {
  key: 0,
  class: "goods-tips"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "goods-status" }, "已购买", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "goods-buy-tips" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }),
  /*#__PURE__*/_createTextVNode("25/1-3个问题")
], -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tips" }, " 提交后请保持电话畅通，我们将在1-2个工作日内电话联系您 ", -1))
const _hoisted_19 = { class: "question-list" }
const _hoisted_20 = { class: "question" }
const _hoisted_21 = { class: "question-left" }
const _hoisted_22 = { class: "q-sort" }
const _hoisted_23 = {
  key: 0,
  class: "q-status"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "q-title" }
const _hoisted_26 = { class: "question-right" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "question" }
const _hoisted_29 = { class: "question-left" }
const _hoisted_30 = { class: "q-sort" }
const _hoisted_31 = {
  key: 0,
  class: "q-status"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "q-title" }
const _hoisted_34 = { class: "question-right" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 1,
  class: "info-title info-title-pay"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-left" }, "2", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-tips" }, "支付", -1))
const _hoisted_40 = [
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = {
  key: 2,
  class: "pay-info"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info" }, "还需支付", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-a-Group14379" }, null, -1))
const _hoisted_44 = { class: "price" }
const _hoisted_45 = {
  key: 3,
  class: "info-title info-title-submit"
}
const _hoisted_46 = { class: "title-left" }
const _hoisted_47 = { class: "info submit-q" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeHead = _resolveComponent("HomeHead")!
  const _component_ShowQuestion = _resolveComponent("ShowQuestion")!
  const _component_AddQuestion = _resolveComponent("AddQuestion")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_HtmlFooter = _resolveComponent("HtmlFooter")!
  const _component_Title = _resolveComponent("Title")!
  const _component_PayDialog = _resolveComponent("PayDialog")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HomeHead),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass(["serviceInfo", { 'hide-add': _ctx.hideAdd }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.hideAdd)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "1"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.isBuyed() ? "再次提问" : "提问"), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _ctx.changeUrl(_ctx.committed.data.photo)
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.committed.data.names), 1),
                (_ctx.committed.data.is_consult == 1)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _hoisted_17))
                  : _createCommentVNode("", true),
                _hoisted_18
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.committed.data.list, (question, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(index + 1), 1),
                  (question.status == 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "【已咨询】"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_24, "  ")),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(question.content), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.toSee(index))
                  }, "查看", 8, _hoisted_27)
                ])
              ]),
              _withDirectives(_createVNode(_component_ShowQuestion, { question: question }, null, 8, ["question"]), [
                [_vShow, question.isShow]
              ])
            ], 64))
          }), 256)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uncommitted.params.list, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", _hoisted_30, _toDisplayString(index + 1 + _ctx.committed.data.list.length), 1),
                  (item.status)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, "【已咨询】"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_32, "  ")),
                  _createElementVNode("span", _hoisted_33, _toDisplayString(item.content), 1)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.todelete(index))
                  }, "删除", 8, _hoisted_35),
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.toshow(index))
                  }, "修改", 8, _hoisted_36)
                ])
              ]),
              _withDirectives(_createVNode(_component_AddQuestion, {
                class: "editQuestion",
                questionInfo: item,
                index: index,
                onAddToUnCommitted: _ctx.addToUnCommitted
              }, null, 8, ["questionInfo", "index", "onAddToUnCommitted"]), [
                [_vShow, item.isShow == 1]
              ])
            ], 64))
          }), 256))
        ]),
        (!_ctx.hideAdd)
          ? (_openBlock(), _createBlock(_component_AddQuestion, {
              key: 0,
              onAddToUnCommitted: _ctx.addToUnCommitted
            }, null, 8, ["onAddToUnCommitted"]))
          : _createCommentVNode("", true),
        (!_ctx.hideAdd && _ctx.payPrice > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_40))
          : _createCommentVNode("", true),
        (!_ctx.hideAdd && _ctx.payPrice > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_41, [
              _hoisted_42,
              _hoisted_43,
              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.payPrice), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.hideAdd)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.payPrice > 0 ? 3 : 2), 1),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.submitq,
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交问题")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createVNode(_component_HtmlFooter),
    _createVNode(_component_Dialog, {
      ref: "toPay",
      dialogwidth: "503px"
    }, {
      header: _withCtx(() => [
        _createVNode(_component_Title, {
          headerHeight: 40,
          headerBC: "#fff"
        }, {
          edit: _withCtx(() => [
            _createElementVNode("i", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mclose())),
              class: "icon iconfont icon-shanchu",
              style: {"font-size":"12px"}
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_PayDialog, { creatOrderInfo: _ctx.creatOrderInfo }, null, 8, ["creatOrderInfo"])
      ]),
      _: 1
    }, 512)
  ]))
}